// extracted by mini-css-extract-plugin
export default {"sidebarInfo":"sidebar-module__sidebarInfo__jSXxR","separator":"sidebar-module__separator__aQfCX"};